import { COMMISSIONS_POLICIES_GET_CHECKED_INCENTIVES } from '../constants'

export function reducer(state, action) {
  if (action.type === COMMISSIONS_POLICIES_GET_CHECKED_INCENTIVES) {
      return {
        ...state,
        policies: {
          ...state.policies,
          listIncentives: action.data.listIncentives
        }
      }
  }
  else{
    return state
  }      
}
